.wrapper {
  padding: 24px;
  display: block;
  background: var(--white-layout-301-level-0-elevation);

  &:after {
    content: '';
    display: block;
    clear: both;
  }

  .right-container {
    float: left;
    width: calc(100% - 366px);
    height: 100%;
  }
  .left-card {
    width: 325px;
    height: 100%;
    float: left;
    border: 1px solid var(--chart-101-pressed-dividers);
    margin-right: calc(var(--spacer) * 5);
    min-height: calc(var(--spacer) * 75);

    #remote-shell-title {
      margin-bottom: calc(var(--spacer) * 3.75);
    }
    .left-card-content {
      padding: calc(var(--spacer) * 2.75) calc(var(--spacer) * 3.25);
    }
    .left-card-footer-buttons {
      margin-top: auto;
      border-top: 1px solid var(--chart-101-pressed-dividers);
      padding: calc(var(--spacer) * 1.5) calc(var(--spacer) * 3.25);
    }
  }

  &.is-error {
    .left-card,
    .right-container {
      display: none;
    }

    .remote-shell-error {
      display: flex;
    }
  }

  &:not(is-error) {
    .left-card {
      display: flex;
      flex-direction: column;
    }
    .right-container {
      display: block;
    }

    .remote-shell-error {
      display: none;
    }
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    background: var(--chart-304-icon-buttons);
    z-index: 5; // xterm-cursor-layer has biggest z-index (=3), and we need to disable clickin on the terminal

    gz-progress-spinner {
      text-align: center;
      z-index: 4;
    }
  }
}

.remote-shell-error {
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;

  gz-image-repo {
    width: 500px;
    height: auto;
  }
}

.connection-details {
  padding: 22px 26px;

  .connection-details-title {
    padding: 0 0 calc(var(--spacer) * 2.12) 0;
    color: var(--black-layout-700-primary);
    opacity: 0.5;
    text-transform: uppercase;
  }
}

.buttons-container {
  display: flex;
  align-items: center;

  gz-tooltip[id='download-button-tooltip'] {
    margin-left: var(--spacer);
  }
}
